import { ref } from "vue";

const message = ref("");
let clearTimer = null;

/**
 * Shared composable providing a single aria-live announcement channel.
 * Only one LiveAnnouncer.vue instance should be mounted in the app;
 * any component can call `announce()` to push a message to it.
 */
export function useLiveAnnouncer() {
  function announce(text) {
    if (clearTimer) clearTimeout(clearTimer);
    // Clear first so identical back-to-back messages are re-announced
    message.value = "";
    requestAnimationFrame(() => {
      message.value = text;
    });
    clearTimer = setTimeout(() => {
      message.value = "";
      clearTimer = null;
    }, 3000);
  }

  return { message, announce };
}
